export default __webpack_public_path__ + "static/logo-app-a5b48c8ceefeb6a65aeebdbeb5d467ef.png";